import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import adminRequest from 'utils/adminRequest'
import authRequest from 'utils/authRequest'
import instituteRequest from 'utils/instituteRequest'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import elasticSearchSyncRequest from 'utils/elasticSearchSyncRequest'
export const SET_INSTITUTES_LIST = 'SET_INSTITUTES_LIST'
export const SET_SINGLE_INSTITUTES_DATA = 'SET_SINGLE_INSTITUTES_DATA'
export const SET_INSTITUTES_METRICS_DATA = 'SET_INSTITUTES_METRICS_DATA'
export const SET_INSTITUTE_GENERATED_LINK = 'SET_INSTITUTE_GENERATED_LINK'

export const setInstitutesList = data => {
  return {
    type: SET_INSTITUTES_LIST,
    data,
  }
}

export const setSingleInstituteData = data => {
  return {
    type: SET_SINGLE_INSTITUTES_DATA,
    data,
  }
}

export const setInstituteGeneratedLink = data => {
  return {
    type: SET_INSTITUTE_GENERATED_LINK,
    data,
  }
}

export const setInstituteMetricsData = data => {
  return {
    type: SET_INSTITUTES_METRICS_DATA,
    data,
  }
}

export const getInstitutesListData =
  ({ currentPage, searchBy, filterData, sortBy, setLoading }) =>
  async (dispatch, getState) => {
    if (setLoading) {
      setLoading(true)
    }
    const current = currentPage
      ? `pageLimit=10&pageNo=${currentPage}`
      : `pageLimit=10&pageNo=0`
    const search = searchBy ? `&search=${searchBy}` : ''
    const statusInstitute = filterData?.status
      ? `&status=${filterData?.status}`
      : ''
    const locationFilter = filterData?.location
      ? `&location=${filterData?.location}`
      : ''
    const sort = sortBy ? `&sort=name&orderBy=${sortBy}` : ''

    try {
      const data = await elasticSearchRequest.get(
        `/institutes?${current}${search}${statusInstitute}${locationFilter}${sort}`
      )
      dispatch(setInstitutesList(data?.data?.data || []))
      if (setLoading) setLoading(false)
    } catch (error) {
      if (setLoading) setLoading(false)
    }
  }

export const editInstitute =
  (corporate_id, data, setPrevDrawer, onClearAll) =>
  async (dispatch, getState) => {
    try {
      await adminRequest.put(`/institutes`, data)

      function formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
      
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
      
        return [year, month, day].join('-');
      }

   
        let payloadData = {
          query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
        };

      await elasticSearchSyncRequest.post(`/sync/institutes_master`,payloadData)
      await elasticSearchSyncRequest.post(`/sync/institute_locations`,payloadData)

      dispatch(getInstitutesListData({}))
      onClearAll()
      SuccessMessage('Institute created successfully.')
      setPrevDrawer(false)
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const institutesMetricsData = () => async (dispatch, getState) => {
  try {
    const res = await adminRequest.get(`/institutes`)
    dispatch(setInstituteMetricsData(res?.data?.data || {}))
  } catch (error) {}
}

export const createInstitute =
  (data, callBackSuccess, callBackError) => async (dispatch, getState) => {
    try {
      const result = await adminRequest.post(`/institutes`, data)
      dispatch(getInstitutesListData({}))
      function formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
      
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
      
        return [year, month, day].join('-');
      }

   
        let payloadData = {
          query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
        };

      await elasticSearchSyncRequest.post(`/sync/institutes_master`,payloadData)
      await elasticSearchSyncRequest.post(`/sync/institute_locations`,payloadData)

      SuccessMessage('Institute Added successfully.')

      dispatch(
        setInstituteGeneratedLink({
          generatedLink: result?.data?.data?.generatedLink,
          id: result?.data?.data?.id,
        })
      )
      if (callBackSuccess) {
        callBackSuccess()
      }
    } catch (error) {
      if (callBackError) {
        callBackError()
      }
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const reInviteInstitute =
  (email, callBack = '') =>
  async dispatch => {
    try {
      const data = await authRequest.get(`/users/resentCredentials/${email}`)
      if (data.status === 200) {
        if (callBack) {
          callBack()
        } else {
          SuccessMessage('Resend Invite Successfully')
        }
      }
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const InstituteRequestforChange =
  (InstituteId, payLoad, callBack) => async dispatch => {
    try {
      let response = await authRequest.post(
        `/users/requestForChange/${InstituteId} `,
        payLoad
      )

      function formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
      
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
      
        return [year, month, day].join('-');
      }

   
        let payloadData = {
          query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
        };

      await elasticSearchSyncRequest.post(`/sync/institutes_master`,payloadData)
      await elasticSearchSyncRequest.post(`/sync/institute_locations`,payloadData)

      callBack()
      SuccessMessage('Request Sent Successfully')
      return response?.data?.message === 'Success'
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)

      return error
    }
  }
